import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Media from './media';
import Title from './title';
import Advertorial from '../../advertorial/advertorial';
import Ad from '../../ad/ad';

export default class Header extends Component {
  shouldComponentUpdate() {
    return false;
  }

  renderAdvertorial() {
    const { advertorial, tags, combinedAdModel } = this.props;

    if (advertorial) {
      return <Advertorial tags={tags} adModel={combinedAdModel} />;
    }

    return null;
  }

  renderSponsorLogo() {
    const { post, combinedAdModel } = this.props;
    if (post.id === 90293556 || post.id === 90312130) {
      return (
        <Ad
          {...combinedAdModel}
          name="sponsorlogo"
          noBorder={true}
          slug={false}
        />
      );
    }

    return null;
  }

  renderDeck() {
    const { post } = this.props;
    const allowedLayouts = ['long', 'hero'];

    if (
      allowedLayouts.indexOf(post.layout) > -1 ||
      post.id === 90282450 ||
      post.id === 90282460 ||
      post.id === 90282468
    ) {
      return (
        <h2
          className="post__deck"
          dangerouslySetInnerHTML={{ __html: post.excerpt }}
        />
      );
    }

    return null;
  }

  render() {
    const {
      config,
      tags,
      post,
      isVideoPost,
      isFirstPost,
      live,
      insert
    } = this.props;

    return (
      <header className="post__header">
        {insert ? '' : this.renderAdvertorial()}
        {this.renderSponsorLogo()}
        <div
          className={
            insert
              ? 'post__header-text article__preview__title'
              : 'post__header-text'
          }
        >
          <Title
            config={config}
            isFirstPost={isFirstPost}
            post={post}
            tags={tags}
            live={live}
            insert={insert}
          />
          <div className={insert ? 'article__preview__deck' : ''}>
            {this.renderDeck()}
          </div>
        </div>

        {insert ? (
          ''
        ) : (
          <Media
            config={config}
            post={post}
            isVideoPost={isVideoPost}
            isFirstPost={isFirstPost}
          />
        )}
      </header>
    );
  }
}

Header.defaultProps = {
  insert: false
};

Header.propTypes = {
  config: PropTypes.shape({}).isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  advertorial: PropTypes.bool.isRequired,
  post: PropTypes.shape({}).isRequired,
  combinedAdModel: PropTypes.shape({}).isRequired,
  isFirstPost: PropTypes.bool.isRequired,
  isVideoPost: PropTypes.bool.isRequired,
  live: PropTypes.bool.isRequired,
  insert: PropTypes.bool
};
